<template>
    <div id="app">
        <router-view/>
        <!--<remote-css href="https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css"></remote-css>-->
        <remote-js src="https://a.amap.com/jsapi_demos/static/demo-center/js/demoutils.js"></remote-js>
        <!--<remote-js src="https://cache.amap.com/lbs/static/addToolbar.js"></remote-js>-->
        <!--    <remote-js src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"></remote-js>-->
    </div>
</template>

<script>
    import request from "./utils/request";
    import wx from 'weixin-js-sdk'
    import qs from 'querystring'

    export default {
        components: {
            'remote-css': {
                render(createElement) {
                    return createElement('link', {attrs: {rel: 'stylesheet', href: this.href}});
                },
                props: {
                    href: {type: String, required: true},
                },
            },
            'remote-js': {
                render(createElement) {
                    return createElement('script', {attrs: {type: 'text/javascript', src: this.src}});
                },
                props: {
                    src: {type: String, required: true},
                },
            }
        },
        data() {
            return {
                globalPosition: {
                    lat: "",
                    lon: ""
                },
            };
        },
        methods: {
            getWxConfig() {
                if (localStorage.getItem('openid') && localStorage.getItem("isLogin") === '1') {
                    request.sendGet({
                        url: "/wx/pay/signature",
                        params: {
                            url: location.href
                        }
                    }).then(res => {
                        if (res.data.code === 0) {
                            var data = res.data.data;
                            wx.config({
                                beta: true,// 必须这么写，否则在微信插件有些jsapi会有问题
                                appId: data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                                timestamp: parseInt(data.timestamp, 10), // 必填，生成签名的时间戳
                                nonceStr: data.nonceStr, // 必填，生成签名的随机串
                                signature: data.signature,// 必填，签名，见附录1
                                jsApiList: ['getLocation', 'openLocation', 'updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                            });
                        }
                    })
                }

            },
            //自身位置
            updateDriverPosition(tripId) {
                if (localStorage.getItem('openid') && localStorage.getItem("isLogin") === '1') {
                    let me = this;
                    wx.ready(function () {
                        wx.checkJsApi({
                            jsApiList: [
                                'getLocation'
                            ]
                        });
                        wx.getLocation({
                            success: function (res) {
                                request.sendPost({
                                    url: '/sharecar/trip/uplocation/' + tripId,
                                    params: {
                                        latitude: res.latitude,
                                        longitude: res.longitude,
                                    }
                                });
                            },
                            fail: function (error) {
                                this.$toast.fail("获取地理位置失败，请确保开启GPS且允许微信获取您的地理位置！");
                            }
                        });
                    });
                    wx.error(function (res) {
                        console.log(res);
                    });
                }

            },
        },
        mounted() {
            console.log(this.$route) ;
        },
        created() {
            console.log(this.$route) ;
            this.getWxConfig();
            let url = location.href ;
            if(url.indexOf("code") == -1){
                if (localStorage.getItem('openid') && localStorage.getItem("isLogin") === '1') {
                    let openid = localStorage.getItem('openid');
                    // config.headers['openid'] = openid;
                } else {
                    if(window.location.href.indexOf('register')!=-1){
                        // return false ;
                    }else{
                        localStorage.clear();
                        request.axios.get('/wx/syncauthorize')
                            .then(function (response) {
                                    if (response.data.code === 0) {
                                        //获取到验证URL,给微信发送请求
                                        let authURL = response.data.data.url;
                                        // console.log(authURL);
                                        window.location.href = authURL;
                                    }
                                }
                            ).catch(function (error) {
                            console.log(error);
                        });
                    }
                    // throw new Error("logout");
                }
            }

            // this.timer = setInterval(this.getDriverPosition, 2 * 60 * 1000);
        },
        beforeDestroy() {
            // clearInterval(this.timer);
        },
        watch: {
            '$route': function (){
                let url = location.href ;
                if (url.indexOf("code") != -1) {
                    let str = url.substr(url.indexOf("?") + 1);
                    let strs = str.split("&");
                    let code = strs[0].split("=")[1] ;
                    let url2 = "/wx/getopenid?" + qs.stringify({code: code});
                    request.axios.get(url2).then(res => {
                        if (res.data.code === 0) {
                            let openid = res.data.data.openid;
                            localStorage.setItem("openid", openid);
                            request.axios.post(
                                '/wx/login', qs.stringify({openid: openid})).then((res) => {
                                if (res.data.code === 0) {
                                    if (res.data.data.isLogin === "1") {
                                        //登陆成功
                                        localStorage.setItem("isLogin", "1");
                                        window.location.href = location.protocol+"//"+location.hostname + "/#/"+ localStorage.getItem('SharePath') ;
                                        localStorage.setItem('SharePath', '') ;
                                    }
                                } else if(res.data.code === 2){
                                    window.location.href = location.protocol+"//"+location.hostname + "/#/register";
                                }else{
                                    this.$toast(res.data.msg);
                                }
                            })
                        }else if(res.data.code === 2){
                            window.location.href = location.protocol+"//"+location.hostname + "/#/register";
                        }else{
                            this.$toast(res.data.msg);
                        }
                    }).catch(error => {
                        console.log(error);
                    });
                }else{
                    // console.log(location.href.split('/#/')[1]) ;
                    if(!localStorage.getItem('SharePath')){
                        localStorage.setItem('SharePath', location.href.split('/#/')[1]) ;
                    }
                    console.log(localStorage.getItem('SharePath')) ;
                }


                // console.log(window.location.href) ;
                let ShareLink = location.protocol + "//" + location.hostname + "/#/" + location.href.split('/#/')[1] || 'user' ; //默认分享链接
                let ShareImgUrl = "https://gstptravel.oss-cn-zhangjiakou.aliyuncs.com/static/images/cklogo.png"; // 分享图标
                let ShareTitle = '昌坤巴士'; // 分享标题
                let ShareDesc = ''; // 分享描述
                wx.ready(function () {
                    //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                    wx.updateAppMessageShareData({
                        title: ShareTitle, // 分享标题
                        desc: ShareDesc, // 分享描述
                        link: ShareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: ShareImgUrl, // 分享图标
                        success: function () {
                            // 设置成功
                        }
                    });
                    wx.updateTimelineShareData({
                        title: ShareTitle, // 分享标题
                        link: ShareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: ShareImgUrl, // 分享图标
                        success: function () {
                            // 设置成功
                        }
                    })
                });
                wx.error(function (res) {
                    console.log(res);
                });
            }
        }
    }
</script>

<style>
    @import '../common.css';

    body {
        font-size: 16px;
        background-color: #f8f8f8;
        -webkit-font-smoothing: antialiased;
    }

    /*修改vant输入框字体大小为16px用来解决ios点击输入框页面放大的问题*/
    .van-field__control {
        font-size: 16px;
    }
</style>
